export enum KeyboardShortcutScope {
    Chat = "chat",
    ChatAndEmail = "chatAndEmail",
    Default = "all",
    Email = "email",
    Modal = "modal",
}

export default KeyboardShortcutScope;
